import React, { useState } from "react";
import { MdCancel } from "react-icons/md";
import { SiGooglemessages } from "react-icons/si";
import { useGetGeneralDataQuery } from "../redux/feature/slice/service-api";

const SmsBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { data } = useGetGeneralDataQuery();

  const phoneRaw = data?.generalData?.phone || "";

  // Prepare phone for WhatsApp: prepend '88' only if not starting with '88'
  const phoneForWhatsApp = phoneRaw.startsWith("88") ? phoneRaw : `88${phoneRaw}`;
  const phoneForCall = phoneRaw; // use raw phone for tel: link

  // Extract Facebook Messenger username from the URL
  const facebookUrl = data?.generalData?.facebook || "";
  let fbUsername = "";
  if (facebookUrl) {
    try {
      const urlObj = new URL(facebookUrl);
      fbUsername = urlObj.pathname.replace(/^\/+|\/+$/g, "");
    } catch (error) {
      fbUsername = facebookUrl.split("/").filter(Boolean).pop() || "";
    }
  }

  return (
    <div className="container mx-auto px-2 lg:px-20 h-full relative">
      {isOpen && (
        <div className="absolute bottom-20 flex flex-col items-center animate-slide-up space-y-2">
          {/* WhatsApp */}
          {phoneRaw && (
            <a
              href={`https://wa.me/${phoneForWhatsApp}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/whatsapp.png" alt="WhatsApp" className="w-11" />
            </a>
          )}

          {/* Messenger */}
          {fbUsername && (
            <a
              href={`https://m.me/${fbUsername}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/images/messenger.png"
                alt="Facebook Messenger"
                className="w-10"
              />
            </a>
          )}

          {/* Phone Call */}
          {phoneRaw && (
            <a href={`tel:${phoneForCall}`}>
              <img
                src="/images/telephone-call.png"
                alt="Call"
                className="w-10"
              />
            </a>
          )}
        </div>
      )}

      {/* Toggle Button */}
      <div>
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          aria-label={isOpen ? "Close chat options" : "Open chat options"}
        >
          {isOpen ? (
            <MdCancel className="w-12 h-12 text-base_700" />
          ) : (
            <SiGooglemessages className="w-12 h-12 text-primary" />
          )}
        </button>
      </div>
    </div>
  );
};

export default SmsBot;
